var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.categories.length > 0)?_c('div',{staticClass:"slider-wrapper"},[_c('div',{staticClass:"slider"},_vm._l((_vm.categoriesList),function(item,index){return _c('img',{key:index,staticClass:"slider-item",attrs:{"src":item.src},on:{"click":function($event){return _vm.selectCate(item)}}})}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }